//#region Imports

import { Component, Input, Signal } from '@angular/core';
import { NgClass } from '@angular/common';
import { MenuService } from '../menu/services/menu.service';

//#endregion

@Component({
    selector: 'l-layout',
    templateUrl: './layout.component.html',
    standalone: true,
    imports: [
        NgClass
    ]
})
export class LayoutComponent {

  //#region Constructor

  constructor(
    private readonly menuService: MenuService,
  ) {}

  //#endregion

  //#region Public Properties

  @Input()
  public fullscreen: boolean = false;

  public shortMode: Signal<boolean> = this.menuService.short;

  //#endregion

}
